import React, { useEffect, useReducer, useRef, useState } from 'react'
import Modal from '../../../../../Modal/Modal';



import { useDispatch, useSelector } from 'react-redux';

import classes from "../Sigfox/SigfoxModalForm.module.css"
import Input from '../../../../../CustomDropDown/Input/Input';
import Button1 from '../../../../Button/Button1';
import { addCamectAPI, addSigfoxAPI, linkLockAPI, updateCamectAPI } from '../../../../../../Api Methods/Api';
import { checkAuthLoader } from '../../../../../../auth';
import Button2 from '../../../../Button/Button2';
import Lottie from 'lottie-react';
import successAnim from '../../../../../../assets/animations/success.json'
import failAnim from '../../../../../../assets/animations/fail.json'
import { serviceActions } from '../../../../../../store/service-Slice';
import { Button } from 'primereact/button';

const LockIDReducer = (state, action) => {

    if (action.type === 'USER_INPUT') {
        return { value: action.val, isValid: action.val.length > 0 };
    }

    if (action.type === 'INPUT_BLUR') {
        return { value: state.value, isValid: state.value.length > 0 };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { value: action.val, isValid: null };
    }
    //otherwise 
    return { value: '', isValid: false };
}


const LockModalForm = ({ setShowVirtualSource, outputs, fetchVirtualSources, setHasDeviceChanged }) => {

    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const DeviceUUID = useSelector(state => state.auth.DeviceUUID);

    const apiData = {
        token,
        client
    }

    const [modalComponent, setModalComponent] = useState(null);
    const [modalPageIndex, setModalPageIndex] = useState(0);
    const [title, setTitle] = useState("")
    const [pinSelected, setPinSelected] = useState(null)

    const siteData = useSelector(state => state.service.SiteData)

    //------------------------------- Modal Logic  ----------------------------------------------

    const ModalDialog = useRef();

    // call ref to clearStates method from child component ScheduledAction.
    const ClearStatesChildComponetRef = useRef();

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();

        HandelResetModal();
    }
    //-------------------------------------------------------------------------------------------------

    // reset model when Escape key is pressed
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                // Handle the Escape key press here
                HandelResetModal();
            }
        };

        // Add event listener when component mounts
        document.addEventListener('keydown', handleKeyDown);


        // Clean up event listener when component unmounts
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const [formIsValid, setFormIsValid] = useState(false);

    const [lockIDState, dispatchLockIDState] = useReducer(LockIDReducer, {
        value: '',
        isValid: null
    });

    const lockIDInputRef = useRef();

    const { isValid: lockIDIsValid } = lockIDState;

    useEffect(() => {
        const identifier = setTimeout(() => {
            setFormIsValid(lockIDIsValid)
        }, 500);

        return () => {
            clearTimeout(identifier);
        };
    }, [lockIDIsValid]);

    const lockIDChangeHandler = (event) => {
        dispatchLockIDState({ type: 'USER_INPUT', val: event.target.value });
    }

    const validateLockIDHandler = () => {
        dispatchLockIDState({ type: 'INPUT_BLUR' });
    }


    const HandelResetModal = () => {
        setModalPageIndex(null);
        setShowVirtualSource(null);
    }

    const onClearHandler = () => {
        dispatchLockIDState({ type: 'INPUT_CLEAR', val: "" })
    }

    const dispatch = useDispatch();
    //10.250.5.69
    //tech.resure

    const submitHandler = async (event) => {
        event.preventDefault();

        const body = {
            deviceUUID: DeviceUUID,
            lockID: lockIDState.value,
            outputPin: String(pinSelected),
            type: "Admin"
        }

        const response = await linkLockAPI(apiData, body, dispatch)
        if (response.success){
            //close modal
            // HandleCloseModal();
            // fetchVirtualSources();
            // setModalPageIndex(-1);
            showSuccess();
            

            
            // const newLock = {
            //     lockID: lockIDState.value, 
            //     adminKey: "", 
            //     battery: 0,
            //     batteryReadAt: "",
            //     tzid: "Eurpoe/London", 
            //     masterPin: "", 
            //     outputPin: String(pinSelected), 
            //     type: "Admin"
            // }

            // let newData = {
            //     ...siteData,
            //     iglooLocks: [
            //         ...(siteData.iglooLocks || []), 
            //         newLock                        
            //     ]
            // }

            //dispatch(serviceActions.setSiteData(newData))
            //refresh
            setHasDeviceChanged(true)
        } else {
            let errorMessage = response.msg
            if (errorMessage == "Smart lock already linked to a UIPIOID"){
                errorMessage = "Smart lock/Keybox already linked to a site"
            }
            //HandleCloseModal();
            setModalPageIndex(-1)
            showError(errorMessage)
        }
    };

    const showError = (message) => {
        setTitle("Error")
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Lottie animationData={failAnim} loop={false} style={{ width: 150, height: 150, margin: "0px" }} />
                <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>{message}</h3>
                <br />
                    <Button  icon="pi pi-times" onClick={HandleCloseModal} label="Close" severity='secondary'/>
                
            </div>
        )

        HandleShowModal();
    }

    const ReloadPage = () => {
        HandleCloseModal();
        window.location.reload();
    }

    const showSuccess = () => {
        setTitle("Success")
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Lottie animationData={successAnim} loop={false} style={{ width: 250, height: 250, margin: "0px" }} />
                <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>Smart Padlock/Keybox linked successfully</h3>
                <h4 style={{ textAlign: "center", color: "#6e6e6eff" }}>Page will have to reload for changes to take effect. Press 'Close' to continue</h4>
                <br />
                    <Button  icon="pi pi-refresh" onClick={ReloadPage} label="Close" severity='secondary'/>
                
            </div>
        )

        HandleShowModal();
    }


    const HandlePinSelected = (pin) => {
        setPinSelected(pin);
        setModalPageIndex(1);
    }

    useEffect(() => {
        setTitle("Link Smart Padlock/Keybox")
        switch (modalPageIndex) {
            case 0:
                setModalComponent(
                    <form onSubmit={submitHandler} className={classes["container"]} method="dialog">
                    <h3 style={{color:"#6e6e6e"}}>Which switch would you like to link the Smart Padlock or Keybox to?</h3>
                    <br></br>
                    <br></br>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "15px" }}>
                        
                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", gap: "20px", width: "100%" }}>
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", gap: "20px", width: "100%" }}>
                                <ul style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "center", gap: "10px" }}>
                                {outputs.map((output) => {
                                        return (
                                            <li key={output.Pin}>
                                                <Button2 style={{minWidth:"350px", minHeight:"50px"}}type={"button"} onClick={() => HandlePinSelected(output.Pin)}>
                                                    {output.pinName}
                                                </Button2>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                </form>
                )

                HandleShowModal();
                break;
            case 1:
                setModalComponent(
                    <form onSubmit={submitHandler} className={classes["container"]} method="dialog">
                        <ul className={classes["inputs-list"]}>
                            <li className={classes["input-container"]}>
                                <label className={classes.subTitle}>What are the Smart Padlock or Keybox details?</label>
                                <Input
                                    className={classes.input}
                                    placeholder={"Smart Lock ID"}
                                    ref={lockIDInputRef}
                                    id="LockID"
                                    type={"text"}
                                    isValid={lockIDState.isValid}
                                    value={lockIDState.value}
                                    onChange={lockIDChangeHandler}
                                    onBlur={validateLockIDHandler}
                                />

                            </li>
                        </ul>
                        <br/>
                        <Button  icon="pi pi-save" type="submit" label="Save" severity='success'/>
                        
                    </form>
                )
                HandleShowModal();
                break;
        }
    }, [modalPageIndex, lockIDState]); // Empty dependency array ensures it runs only once after initial render

    return (
        <>
            <Modal ref={ModalDialog} title={title} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} modalLayoutStyle={{ alignItems: "center" }}>
                {modalComponent}
            </Modal>
        </>
    )
}

export default LockModalForm;